import React from 'react';
import { View } from 'react-native';

import { Typography } from '@components/Typography';
import { Theme, makeStyles, useTheme } from '@providers/Theme';

type Preset = 'error' | 'warning' | 'success';
type PresetDef = (theme: Theme) => {
  light: string;
  main: string;
};

const presets: Record<Preset, PresetDef> = {
  error: (theme) => ({
    light: theme.palette.primary[100]!,
    main: theme.palette.primary[600]!,
  }),
  warning: (theme) => ({
    light: theme.palette.yellow[50]!,
    main: theme.palette.yellow[500]!,
  }),
  success: (theme) => ({
    light: theme.palette.success[50]!,
    main: theme.palette.success[400]!,
  }),
};

type BadgePropsStyle = {
  color: string;
  backgroundColor: string;
};

type BadgeProps = {
  label: React.ReactNode;
  preset: Preset;
};

const useStyles = makeStyles<BadgePropsStyle>((theme) => ({
  root: (props) => ({
    ...theme.mixins.padding(0.5, 1),
    borderRadius: 16,
    backgroundColor: props.backgroundColor,
  }),
  text: (props) => ({
    color: props.color,
  }),
}));

export const Badge: React.FC<BadgeProps> = ({ label, preset }) => {
  const presetDef = presets[preset];
  const theme = useTheme();
  const { light, main } = presetDef(theme);
  const styles = useStyles({ backgroundColor: light, color: main });
  return (
    <View style={styles.root}>
      <Typography style={styles.text}>{label}</Typography>
    </View>
  );
};
